// extracted by mini-css-extract-plugin
var _1 = "qeNvwU38";
var _2 = "OorWLP01";
var _3 = "srjq4qqN";
var _4 = "_2sMM2M3t";
var _5 = "_2sMM2M3t";
var _6 = "yUPpWD5i";
var _7 = "cofxMnbS";
var _8 = "j9Q8rJUy";
var _9 = "wNkxB9NQ";
var _a = "fYEoGBLZ";
export { _1 as "blue", _2 as "details", _3 as "grape", _4 as "grape-info", _5 as "grapeInfo", _6 as "grapeType", _7 as "green", _8 as "summary", _9 as "synonyms", _a as "title" }
